import { render, staticRenderFns } from "./SlotRankingsList.vue?vue&type=template&id=d8ca4092&"
import script from "./SlotRankingsList.vue?vue&type=script&lang=js&"
export * from "./SlotRankingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports